<template>
  <b-tabs id="tbasRsaRefertiList" ref="tbasRsaRefertiList" v-model="activeTabIndex" nav-wrapper-class="sa-tab-items"
    content-class="mt-3" class="sa-tab" style="height: 100%; padding-bottom: 25px" fill @input="onInputTabs">
    <b-tab title="Armadietto Giacenze">
      <magazzino-articoli-storico-giacenze-component :visibleColumns="visibleColumnArray"
        ref="cmpMagazzinoArticoliStoricoGiacenzeComponent"> </magazzino-articoli-storico-giacenze-component>
    </b-tab>
    <b-tab title="Ricevute">
      <div class="sa-flexbox" style="padding-bottom: 20px">
        <div style="margin-left: 0.5rem; margin-right: 1.5rem">
          <span class="sa-flexbox-body-title">Ricevute</span>
          <b-button size="sm" variant="outline-success outline-primary-noborder float-sm-right" :hidden="false"
            @click="onClickAggiungi" class="mb-2">
            <font-awesome-icon icon="plus"> </font-awesome-icon>
            Aggiungi
          </b-button>
        </div>
        <magazzino-articoli-storico-contabile-component
          ref="cmpMagazzinoArticoliStoricoContabileComponent"></magazzino-articoli-storico-contabile-component>
        <!--- <contabilita-fatturazione-list-component ref="cmpContabilitaFatturazioneListComponent"></contabilita-fatturazione-list-component>-->
        <rsa-paziente-armadietto-ricevute-modal-edit-component ref="cmpRsaPazienteArmadiettoRicevuteModalEdit"
          @saveSuccess="onSaveSuccess"></rsa-paziente-armadietto-ricevute-modal-edit-component>
      </div>
      <contabilita-documento-edit-modal ref="mdlContabilitaDocumentoEditModal" @afterSave="onAfterSave"
        @afterSaveError="onAfterSaveError" :idAccettazione="idAccettazione" />
      <!-- <contabilita-documento-edit-modal-component @afterSave="onAfterSave" @afterSaveError="onAfterSaveError" :idAccettazione="idAccettazione" ref="cmpContabilitaDocumentoEditModalComponent" /> -->
    </b-tab>
  </b-tabs>
</template>

<script>
// import ContabilitaDocumentoEditModalComponent from "../../../contabilita/components/ContabilitaDocumentoDatiDocumentoModalComponent.vue";
import ContabilitaDocumentoEditModal from "../../../contabilita/components/ContabilitaDocumentoEditModal.vue";
import MagazzinoArticoliStoricoContabileComponent from "../../../magazzino/components/MagazzinoArticoliStoricoContabileComponent.vue";
import MagazzinoArticoliStoricoGiacenzeComponent from "../../../magazzino/components/MagazzinoArticoliStoricoGiacenzeComponent.vue";
import RsaPazienteArmadiettoRicevuteModalEditComponent from "./RsaPazienteArmadiettoRicevuteModalEditComponent.vue";
import ContabilitaMixin from "../../../contabilita/mixins/ContabilitaMixin";
import axios from "axios";
import MagazzinoMixins from "../../../magazzino/mixins/MagazzinoMixins";
export default {
  mixins: [ContabilitaMixin, MagazzinoMixins],
  components: { RsaPazienteArmadiettoRicevuteModalEditComponent, ContabilitaDocumentoEditModal, MagazzinoArticoliStoricoGiacenzeComponent, MagazzinoArticoliStoricoContabileComponent },
  props: {
    idAccettazione: { type: String },
  },
  data() {
    return {
      activeTabIndex: 0,
      accettazioneJson: {},
      documentoJson: {},
      visibleColumnArray: ["documento", "articolo", "prezzoUnitario", "quantita", "causaleDocumentoOperazioneMagazzino", "actions"],
      jsonData: {
        numero: null,
      },
    };
  },
  mounted() {
    this.magazzinoMagazziniLoadData();
  },

  methods: {
    init(jsonData) {
      this.jsonData = jsonData;
      this.onInputTabs(0);
    },
    onInputTabs(index) {
      switch (index) {
        case 0:
          this.initComponentStoricoGiacenze({ codiceMagazzino: this.jsonData.numero, codiceStruttura: this.jsonData.codiceStruttura });
          break;
        case 1:
          this.initComponentStoricoContabile({ codiceMagazzino: this.jsonData.numero, codiceStruttura: this.jsonData.codiceStruttura });
          break;
      }
    },
    loadAccettazione() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/accettazioni" + "/" + this.idAccettazione;
      axios
        .get(link)
        .then((response) => {
          me.accettazioneJson = response.data.data;
          this.preparaDocumentoRicevuta();
        })
        .catch(() => { });
    },
    onClickAggiungi() {
      this.preparaDocumentoRicevuta();
    },
    preparaDocumentoRicevuta() {
      this.contabilitaCausaliTipoDocumentoByCodiceLoadData(this.jsonData.codiceStruttura, "RCVPZ", "RCVPZ", this.contabilitaCausaleTipoDocumentoCallback, this.contabilitaCausaleTipoDocumentoCallbackError);
      //this.contabilitaTipoDocumentoByCodiceLoadData(this.jsonData.codiceStruttura, "RCVPZ", this.contabilitaTipoDocumentoCallback);
    },
    contabilitaCausaleTipoDocumentoCallback() {
      this.documentoJson = this.documentoJsonData;
      this.setDatiJsonData();
      this.$refs.mdlContabilitaDocumentoEditModal.init(this.documentoJson);
    },
    setDatiJsonData() {
      let anagrafica = this.jsonData.accettazioneAnagrafica;
      let struttura = this.jsonData.accettazioneStruttura;
      console.log("anagrafica", anagrafica);

      this.documentoJson.strutturaCodice = struttura.codiceStruttura;
      this.documentoJson.strutturaDenominazione = struttura.denominazione;
      this.documentoJson.strutturaDescrizioneBanca = null;
      this.documentoJson.strutturaEmail = struttura.email;
      this.documentoJson.strutturaIban = struttura.iban;
      this.documentoJson.strutturaPartitaIva = struttura.partitaIva;
      this.documentoJson.strutturaPec = struttura.pec;
      this.documentoJson.strutturaTelefono = struttura.telefono;
      this.documentoJson.strutturaIndirizzo = struttura.indirizzo;
      this.documentoJson.strutturaLocalitaCodiceIstat = struttura.localita;
      this.documentoJson.strutturaProvincia = struttura.provincia;
      this.documentoJson.strutturaFax = struttura.fax;
      this.documentoJson.strutturaCodiceFiscale = struttura.codiceFiscale;
      this.documentoJson.strutturaCap = struttura.cap;
      this.documentoJson.soggettoCodiceFiscale = anagrafica.identificativo;
      this.documentoJson.soggettoCognomeRagione = anagrafica.cognome;
      this.documentoJson.soggettoNome = anagrafica.nome;
      this.documentoJson.soggettoCap = anagrafica.capResidenza;
      this.documentoJson.soggettoIndirizzo = anagrafica.indirizzoResidenza;
      this.documentoJson.soggettoProvincia = anagrafica.provinciaResidenza;
      this.documentoJson.soggettoLocalitaCodiceIstat = anagrafica.comuneResidenzaCodiceIstat;
      this.documentoJson.soggettoPartitaIva = "";
      this.documentoJson.magazzinoId = "-1";
      this.documentoJson.magazzinoCodice = this.jsonData.numero;
      this.documentoJson.documentoMarcaBollo = "";
      this.documentoJson.magazzinoDescrizione = anagrafica.cognome.toUpperCase() + " " + anagrafica.nome.toUpperCase();
      this.documentoJson.documentiCollegati = [];

      let magazzino = this.magazzinoMagazziniOptions.filter(e => e.codiceMagazzino == this.jsonData.numero && e.codiceStruttura == struttura.codiceStruttura)
      if (magazzino.length == 1) {
        let armadietto = magazzino[0];
        this.documentoJson.magazzinoId = armadietto.id;
        this.documentoJson.magazzinoCodice = armadietto.codiceMagazzino;
        this.documentoJson.documentoMarcaBollo = "";
        this.documentoJson.magazzinoDescrizione = armadietto.descrizioneMagazzino;
      }
    },
    contabilitaCausaleTipoDocumentoCallbackError() {
      this.$bvToast.toast("Documento con codice RCVPZ non configurato", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
    onSaveSuccess() {
      switch (this.activeTabIndex) {
        case 0:
          this.initComponentStoricoGiacenze({ codiceMagazzino: this.jsonData.numero });
          break;
        case 1:
          this.initComponentStoricoContabile({ codiceMagazzino: this.jsonData.numero });
          break;
      }
    },
    initComponentStoricoGiacenze(filter) {
      this.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init(filter);
    },
    initComponentStoricoContabile(filter) {
      this.$refs.cmpMagazzinoArticoliStoricoContabileComponent.init(filter);
    },
    onAfterSave() {
      this.$bvToast.toast("Salvataggio avvenuto con successo", {
        title: "OK",
        autoHideDelay: 5000,
        variant: "success",
      });

      this.$refs.mdlContabilitaDocumentoEditModal.hide();
      this.$refs.cmpMagazzinoArticoliStoricoContabileComponent.init({ codiceMagazzino: this.jsonData.numero });
      this.$refs.cmpMagazzinoArticoliStoricoGiacenzeComponent.init({ codiceMagazzino: this.jsonData.numero });
    },
    onAfterSaveError(error) {
      let messaggio = error.response.data.messaggio ? error.response.data.messaggio : "Errore non gestito";
      this.$bvToast.toast(messaggio, {
        title: "Attenzione!",
        autoHideDelay: 5000,
        variant: "danger",
      });
    },
  },
};
</script>

<style></style>
